module.exports = __webpack_public_path__ + "static/img/us-1.716663c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/us-1.png
// module id = PBfa
// module chunks = 1